






















import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { LeadService, HistoricoEtapas, Filtro } from "@/services/lead.service";
import Loading from "@/shared/components/loading.vue";
import DataTable from "@/shared/components/data-table.vue";
import { Paginacao } from "@/shared/interface";
import { ServerPageOptions } from "@/shared/utils/datatable";
import { dateTime, dateTimeSeconds } from "@/shared/filters";

@Component({
  components: { Loading, DataTable },
  filters: { dateTimeSeconds, dateTime },
})
export default class AcoesLead extends Mixins(GlobalMixin){
  @Prop() readonly idLead!: number;
  loading = false;
  promise: Promise<Paginacao<HistoricoEtapas>> | null = null;

  filtro: Filtro = {
    offset: 0,
    limit: 100,
    order: "",
  };

  headers = [
    { value: "data", text: "Data" },
    { value: "idEtapaLead", text: "Etapa" },
    { value: "nomeCampanha", text: "Campanha" },
    { value: "mensagemPronta.tituloMensagem", text: "Mensagens Prontas" },
    { value: "status", text: "Status" },
    { value: "usuario.nome", text: "Importado Por" },
  ];

  fetchHistoricoEtapas(options?: ServerPageOptions) {
    if (options) {
      Object.assign(this.filtro, options);
    }
    this.promise = LeadService.listarHistoricoEtapas(this.idLead, this.filtro);
  }

  getNomeEtapaLead(idEtapa: number) {
    switch (idEtapa) {
      case 0:
        return "Oportunidade";
      case 1:
        return "Primeiro Contato";
      case 2:
        return "Segundo Contato";
      case 3:
        return "Atendimento";
      default:
        return idEtapa;
    }
  }
}
